<template>
  <div class="ui-dropdown" ref="item">
    <div class="ui-dropdown--inner">
      <el-button
        class="ui-button"
        :class="{ disabled: disabled }"
        @click.stop="toggle"
      >
        <svg-icon v-if="icon_direction_type === 'left'" :name="icon" class="icon-left" />
        <span v-if="selected_index === -1 && (default_text || is_select_dropdown)">{{ other_text }}{{ default_text }}</span>
        <span v-else-if="only_pick">---Select---</span>
        <span v-else-if="multi_pick">{{ typeof multi_pick === 'boolean' ? 'Tag' : multi_pick }}</span>
        <span v-else>{{ getSelectedItem() ? (prefix ? prefix + getSelectedItem().text : getSelectedItem().text) : '' }}</span>
        <svg-icon v-if="icon_direction_type === 'right'" :name="icon" class="icon-right" />
        <tippy
          :delay="[0, 20]"
          class="tooltip"
          v-if="tooltip_text"
          :content="tooltip_text"
          trigger="mouseenter click"
        />
      </el-button>
      <div
        v-if="is_show_select"
        class="item-box"
        :class="['direction--' + direction_type, { 'direction--top': on_bottom }]"
      >
        <div class="item-box--header" v-if="$slots.header" ref="header" @click.stop>
          <slot name="header" />
        </div>
        <ul class="item-box--list" :style="max_height ? { '--dropdown-fit-height': max_height + 'px' } : null">
          <li
            v-for="(item, index) in items"
            :key="index"
            :class="['select-item', no_icon && 'icon-display-none', item.disabled && 'disabled', item.hide && 'hide']"
            @click.stop="selectType(index)"
          >
            <svg-icon name="yes" v-if="isSelected(item, index) && is_update_index && !only_pick && !multi_pick" />
            <i v-else-if="is_update_index && !only_pick && !multi_pick" class="select-icon" />
            <i v-if="!item.is_selected && multi_pick" class="select-icon" />
            <svg-icon name="yes" v-if="(only_pick && item.click) || (multi_pick && item.is_selected)" />
            <span>{{ item.text }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { ElButton } from 'element-plus';

export default {
  name: 'Dropdown',
  emits: ['is-open'],

  components: {
    ElButton,
  },

  data() {
    return {
      is_show_select: false,
      selected_index: 0,
      on_bottom: false,
      max_height: 0,
      uuid: this.createUuid(),
    };
  },

  watch: {
    is_show_select(val) {
      if (this.spec_drop_filed) {
        this.$store.state.spec_value[this.spec_drop_filed] = val;
      }
      this.$emit('is-open', { type: this.type, value: this.is_show_select });
    },

    '$store.state.spec_value.list_status_open': {
      handler(val) {
        if (val && this.is_show_select && this.spec_drop_filed) {
          this.is_show_select = false;
        }
      },
      deep: true, // deep watch
    },

    handle_open_value(val) {
      if (val && this.is_show_select) {
        this.is_show_select = false;
      }
    },
  },

  props: {
    icon: {
      type: String,
      default: 'arrow',
    },
    is_id: {
      type: Boolean,
      default: false,
    },
    direction_type: {
      type: String,
      default: 'left',
    },
    icon_direction_type: {
      type: String,
      default: 'left',
    },
    items: {
      type: Array,
      default: [],
    },
    default_text: {
      type: String,
      default: '',
    },
    tooltip_text: {
      type: String,
      default: '',
    },
    default_value: {
      type: Number,
      default: 0,
    },
    default_id: {
      type: Number,
      default: null,
    },
    is_update_index: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    is_select_dropdown: {
      type: Boolean,
      default: false,
    },
    array_key: {
      type: Number,
      default: null,
    },
    no_icon: {
      type: Boolean,
      default: false,
    },
    only_pick: {
      type: Boolean,
      default: false,
    },
    multi_pick: {
      type: [Boolean, String],
      default: false,
    },
    spec_drop_filed: {
      type: String,
      default: '',
    },
    type: {
      //需要告訴外層他打開了
      type: String,
      default: '',
    },

    handle_open_value: {
      //監聽他取得是否要關閉selcet
      type: Boolean,
      default: false,
    },

    other_text:{
      type:String,
      default:''
    }
  },

  methods: {
    getSelectedItem() {
      if (this.is_id) {
        return this.items.find((item) => item.id === this.selected_index);
      }
      return this.items[this.selected_index];
    },

    isSelected(item, index) {
      if (this.is_id) {
        return item.id === this.selected_index;
      }
      return index === this.selected_index;
    },

    toggle() {
      this.is_show_select = this.disabled ? false : !this.is_show_select;

      if (this.is_show_select) {
        this.EventBus.emit('close-dropdown-tags', this.uuid);
      }

      this.updateBoxLayout();
      // the header slot only exists once the box is rendered, so measure it again
      if (this.is_show_select && this.$slots.header) this.$nextTick(this.updateBoxLayout);

      this.$emit('toggle', this.getSelectedItem());
    },

    updateBoxLayout() {
      const rect = this.$refs.item.getBoundingClientRect();
      this.on_bottom = rect.bottom > window.innerHeight - 180;

      const box_frame = 18;
      const viewport_gap = 10;
      const header_height = this.$refs.header ? this.$refs.header.offsetHeight : 0;
      const available = this.on_bottom
        ? rect.top - viewport_gap
        : window.innerHeight - rect.bottom - viewport_gap;

      this.max_height = Math.max(available - box_frame - header_height, 60);
    },

    handleResize() {
      if (this.is_show_select) this.updateBoxLayout();
    },

    createUuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    selectType(index) {
      if (this.items[index].disabled) return;
      this.is_show_select = false;
      this.$emit('is-open', { type: this.type, value: this.is_show_select });

      if (this.is_update_index) this.selected_index = this.is_id ? this.items[index].id : index;
      if (this.array_key !== null) this.items[index].the_key = this.array_key;
      this.items[index].old_value_index = this.default_value;
      this.items[index].index_key = index;

      if (this.only_pick) {
        this.items[index].click = this.items[index].click = true;
        this.$emit('update-dropdown', this.items);
      } else {
        this.$emit('update-dropdown', this.items[index]);
      }
    },

    handleClick(e) {
      this.is_show_select = false;
    },
  },

  created() {
    window.addEventListener('click', this.handleClick);
    window.addEventListener('resize', this.handleResize);
  },

  unmounted() {
    window.removeEventListener('click', this.handleClick);
    window.removeEventListener('resize', this.handleResize);
  },

  mounted() {
    if (this.default_value !== 0) this.selected_index = this.default_value;
    if (this.default_id)
      this.selected_index = this.is_id ? this.default_id : this.items.findIndex((e) => e.id === this.default_id);
    if (this.is_id) {
      if (!this.items.find((item) => item.id === this.selected_index)) this.selected_index = this.items[0]?.id || 0;
    } else {
      if (!this.items[this.selected_index]) this.selected_index = 0;
    }

    // handle if need default Text,will hard code default_value==-100
    if (this.default_value === -100) this.selected_index = -1;

    this.EventBus.on('close-dropdown-tags', (uuid) => {
      if (this.uuid !== uuid && this.is_show_select) {
        this.is_show_select = false;
      }
    });
  },
};
</script>
<style lang="scss">
.ui-dropdown {
  &--inner {
    position: relative;

    .ui-button {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;

      .tooltip {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: 3;
        cursor: pointer;
      }

      span {
        // margin-left: 5px;
        font: var(--font-fg-12);
        color: var(--black-60);
      }

      svg {
        width: 8px !important;
        height: 8px !important;
        color: black !important;

        &.icon-left {
          margin-right: 6px !important;
        }

        &.icon-right {
          margin-left: 6px !important;
        }
      }

      &.disabled {
        border: 1px solid var(--black-10);
        cursor: not-allowed;

        .tooltip {
          cursor: not-allowed;
        }

        span {
          color: var(--black-40);
        }

        svg {
          fill: var(--black-40);
        }
      }
    }

    .item-box {
      padding: 8px 0;
      // width: 238px;
      width: max-content;
      background: white;
      border: 1px solid #f2f2f2;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      position: absolute;
      z-index: 11;

      &.direction--right {
        right: 0px;
      }

      &.direction--top {
        bottom: 100%;
      }

      .item-box--header {
        padding: 4px 10px 12px;
        margin-bottom: 8px;
        border-bottom: 1px solid var(--black-10);
      }

      .item-box--list {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: min(var(--dropdown-fit-height, 9999px), var(--dropdown-max-height, 500px));

        &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        &::-webkit-scrollbar-track {
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 4px;
          border: 2px solid transparent;
          background-clip: content-box;
          background-color: var(--black-20);
          transition: 0.2s background-color ease;
        }

        &:hover::-webkit-scrollbar-thumb {
          background-color: var(--black-50);
        }
      }

      .select-item {
        padding: 9px 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: var(--black-90);
        font: var(--font-fg-12);
        // font: unset;
        // font-family: var(--font);
        // font-size: 14px;

        &:hover {
          background: var(--bg-02);
        }

        &.disabled {
          color: var(--black-40);
          cursor: not-allowed;

          .select-icon {
            border: 1px solid var(--black-40);
          }
        }

        &.hide {
          display: none;
        }

        &.icon-display-none {
          svg,
          .select-icon {
            display: none;
          }
        }

        svg {
          width: 12px;
          height: 12px;
          margin-right: 6px;
          fill: var(--dark-blue);
        }

        .select-icon {
          width: 12px;
          height: 12px;
          min-width: 12px;
          min-height: 13px;
          margin-right: 6px;
          border: 1px solid var(--black-50);
          border-radius: 50%;
          background-color: white;
        }
      }
    }
  }
}
</style>
